/** @jsx React.DOM */'use strict';

var assign 	= require('object-assign');
var React 	= require('react');

var logger 	= require('../../utils/logger.js');

var Actions = require('../actions/news-search-actions.js');
var Store 	= require('../stores/news-search-store.js');

var tgApi = require('../../api/tg-api.js');

function getFacetValue(navigatedFacet) {
	return navigatedFacet !== null ? navigatedFacet.value : null;
}

function getFilterRequest(navState, selectedValues) {
	var filterRequest = {
		'baseSearchContext': navState.baseSearchContext,
		'searchContext': navState.searchContext,
		'searchTerm': navState.searchTerm
	};

	if (selectedValues) {
		assign(filterRequest, selectedValues);
	}

	return filterRequest;
}

function loadInitialData(navState) {
	var filterRequest = getFilterRequest(navState);
	Actions.updateFilters(filterRequest);
}

var view = React.createClass({
	getInitialState: function () {
		return Store.getState();
	},

	componentWillMount: function () {
		Store.addChangeListener(this.onStoreChange);
		loadInitialData(this.props.navstate);
	},

	componentWillUnmount: function () {
		Store.removeChangeListener(this.onStoreChange);
	},

	onStoreChange: function () {
		this.setState(Store.getState());
	},

	render: function () {

		var navstate = this.props.navstate;
		var defaultLocation = this.props.defaultLocation;

		var state = this.state;

		logger.debug({
			view: 'News Search',
			message: 'Render',
			state: state
		});

		var searchTermDisabled = state.isLoading;

		var updateButtonText = state.totalResults > 0 ? 'Update results' : 'No matching results found'; 

		var totalResults = state.totalResults;

		return (
			<div>
				<form className="search-filters panel news-search search-filters news-search__form  form" onSubmit={this.submitForm}>
					<div className="row">
						<div className="column large-6 font-small show-for-large-up">
							<p><strong>{navstate.heading}</strong></p>
						</div>
						<div className="column large-6 text-right font-small">
							<p className="search-filters__count">
								{state.totalResults === 1 ? <span><strong className="search-filters__count__value">{totalResults}</strong> matching article found</span> : <span><strong className="search-filters__count__value">{totalResults}</strong> matching articles found</span>}				
							</p>
						</div>
					</div>
					<div className="row">
						<div className="column large-4 large-push-4">
							<input className="searchTermInput" disabled={searchTermDisabled} type="text" value={state.isLoading ? 'Loading...' : state.searchTerm} placeholder="Enter a keyword" onBlur={this.updateSearchTerm} onMouseLeave={this.updateSearchTerm} onKeyPress={this.updateSearchTermKeyPress} />
							{state.searchTerm == null ? null : <span className="news-search__clear-filter" onClick={this.clearSearchTerm}>X</span>}				
						</div>
					</div>
					<a href="#" className="search-filters__clear-filters news-search__clear-filters font-small" onClick={this.clearFilters}>
						<span className="icon fi-loop"></span>
						<span>Clear all filters</span>
					</a>
					<button type="submit" disabled={!totalResults || state.isLoading} className="update search-filters__update-results button radius" onClick={this.submitForm}>
						{updateButtonText}
					</button>
				</form>
			</div>
		);
	},

	updateSearchTerm: function (e) {
		if (!this.state.isLoading) {
			var searchTerm = $(e.target).val();
			if (searchTerm !== '' && searchTerm !== this.state.searchTerm) {
				var filterRequest = getFilterRequest(this.state, {
					'searchTerm': searchTerm
				});
				Actions.updateFilters(filterRequest);
			}
		}
	},

	updateSearchTermKeyPress: function (e) {
		if (!this.state.isLoading && e.key === 'Enter') {
			var searchTerm = $(e.target).val();
			if (searchTerm !== '' && searchTerm !== this.state.searchTerm) {
				var filterRequest = getFilterRequest(this.state, {
					'searchTerm': searchTerm
				});
				Actions.updateFilters(filterRequest);
			}
		}
	},

	submitForm: function (e) {
		e.preventDefault();
		if (!this.state.isLoading) {
			Actions.submitForm(this.state.searchResultsUrl);
		}
	},

	clearFilters: function (e) {
		e.preventDefault();
		var filterRequest = getFilterRequest(this.state, {
			'country': '',
			'region': '',
			'county': '',
			'magazineRating': '',
			'playerRating': '',
			'greenFee': '',
			'twoForeOneValue' : '',
			'searchTerm': ''
		});
		Actions.updateFilters(filterRequest);
	},

	clearSearchTerm: function (e) {
		e.preventDefault();
		var filterRequest = getFilterRequest(this.state, {
			'searchTerm': ''
		});
		Actions.updateFilters(filterRequest);
	}

});

module.exports = view;